import paths from '~/pages/paths';
import { Application } from '~/types/Application';
import { auth } from '~/api/auth';
import { getDecodedJwt } from './getDecodedJwt';

export const getActiveStepPath = (application: Application): string => {
  const decodeToken = getDecodedJwt();
  const cardholderPath = `${paths.cardHolder.details}`;
  const roles = decodeToken?.realm_access?.roles;
  const isCardholder = (roles || []).includes('CARD_HOLDER');

  const { invitationType }: any = getDecodedJwt();
  const invitationTypeStorageKey: any = auth.getInvitationType();
  const isInvitationTypeCardHolder: any =
    invitationType === 'CARD_HOLDER' || invitationTypeStorageKey === 'CARD_HOLDER';
  const isInvitationTypeSignatory: any = invitationType === 'SIGNATORY';

  if (isCardholder && isInvitationTypeCardHolder) {
    auth.setInvitationType('CARD_HOLDER');
    return cardholderPath;
  }

  if (isInvitationTypeSignatory) {
    auth.setInvitationType('SIGNATORY');
  }

  if (!invitationType) {
    auth.clearInvitationType();
  }

  const ALL_PRODUCTS = ['BUSINESS_CARD', 'CORPORATE_EXECUTIVE_CARD', 'DIGITAL_BUSINESS_PAYMENT', 'DIGITAL_TRAVEL_PAYMENT'];
  const lockedProducts = application.payload?.amendmentList?.lockedProducts || [];
  const isAmendment = application.payload?.applicationType === 'AMENDMENT';
  const areAllProductsLocked = ALL_PRODUCTS.every((product) => lockedProducts.includes(product as any));
  if (isAmendment && areAllProductsLocked) {
    return paths.stageResult.allProductsOnboarded;
  }

  switch (application.stage) {
    case 'companyType':
      return paths.companyType._;
    case 'highRisk':
      return paths.getInTouch._;
    case 'terminated':
    case 'fillApplication': {
      const stepKey = application.stagePayload.activeStep.key;

      const stepView = application.stagePayload.activeStep.uiKey;

      switch (stepKey) {
        case 'services.servicesDetails':
          return `${paths.wizard.services}/${stepView}`;
        case 'services.cardOrderDetails':
          return `${paths.wizard.services}/${stepView}`;
        case 'services.adminstrator':
          return `${paths.wizard.services}/${stepView}`;
        case 'services.selectServices':
          return `${paths.wizard.services}/${stepView}`;

        default:
          if (stepKey?.startsWith('application')) {
            return `${paths.wizard.application}/${stepView}`;
          }
          return paths.wizard._;
      }
    }
    case 'waitingForScreening':
      return paths.stageResult.waitingForScreening;
    case 'error':
      return paths.stageResult.error;
    case 'screeningError':
      return paths.stageResult.screeningError;
    case 'screeningReject':
    case 'salesforceReject':
      return paths.stageResult.screeningReject;
    case 'salesforceSoftDecline':
      return paths.stageResult.salesforceSoftDecline;
    case 'salesforceHardDecline':
      return paths.stageResult.salesforceHardDecline;
    case 'allProductsOnboarded':
      return paths.stageResult.allProductsOnboarded;
    case 'salesforceError':
      return paths.stageResult.salesforceError;
    case 'salesforceTechnicalError':
      return paths.stageResult.salesforceTechnicalError;
    case 'submit':
      return paths.stageResult.submit;
    case 'successfulOnboarding':
      return paths.stageResult.successfulOnboarding;
    case 'completed':
      return paths.stageResult.completed;
    case 'contract':
      return paths.wizard.signContract;
    case 'payment':
      return paths.wizard.payment;
    default:
      return paths.stageResult.unknownStage;
  }
};
